var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClientOutOfBed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "31.1,19.5 31.1,21.4 28.6,21.4 22.1,21.4 8.9,21.4 8.9,14 5.2,14 5.2,32.5 8.9,32.5 8.9,26.9 22.8,26.9  25.3,26.9 27.9,26.9 31.1,26.9 31.1,32.5 34.8,32.5 34.8,19.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9,12.3l-2.8-4.2c-0.1-0.2-0.4-0.3-0.6-0.4l-1.7-0.2c-0.7-0.1-1.2,0.7-0.8,1.3c0.3,0.4,0,1-0.5,1 c-0.6,0-1.1,0.1-1.6,0.2c-0.4,0.1-0.8,0.2-1.2,0.3c-0.4,0.2-0.8,0.4-1.2,0.6c-0.9,0.5-1.8,1.3-2.5,2.2c-0.9,1.2-1.7,2.8-2.2,4.6 c0,0.2,0.1,0.3,0.3,0.2c0.3-0.2,3.2-2.3,4.4-2.9c0.1,0,0.1-0.1,0.2-0.1c0.8-0.3,1.5-0.5,2.3-0.6c0.6-0.1,1.2-0.1,1.7,0 c0.1,0,0.2,0.2,0.1,0.3l-1.5,1.4c-0.1,0.1-0.1,0.3,0.1,0.4l3,0.4c0.2,0,0.5,0,0.7-0.2l3.8-3.3C33,13.1,33.1,12.6,32.9,12.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientOutOfBed);
export default __webpack_public_path__ + "static/media/client-out-of-bed.0c1da017bd13a9d20139785629598b71.svg";
export { ForwardRef as ReactComponent };